import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from '@/components/layouts/Header';
import { ToastContainer } from '@/components/ui/Toast';
import { LoadingOverlay } from '@/components/ui/Spinner';
import { useUIStore } from '@/stores/uiStore';

// Pages
import HomePage from '@/pages/HomePage';
import RegistrationPage from '@/pages/RegistrationPage';
import VerifyEmailPage from '@/pages/VerifyEmailPage';
import TicketPage from '@/pages/TicketPage';
import DownloadTicketPage from '@/pages/DownloadTicketPage';
import NotFoundPage from '@/pages/NotFoundPage';

function App() {
  const { toasts, removeToast, isLoading, loadingMessage } = useUIStore();

  return (
    <BrowserRouter>
      <div className="app">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/verify" element={<VerifyEmailPage />} />
          <Route path="/ticket" element={<TicketPage />} />
          <Route path="/ticket/:participantId" element={<TicketPage />} />
          <Route path="/download-ticket/:participantId" element={<DownloadTicketPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        {/* Global UI Components */}
        <ToastContainer toasts={toasts} onClose={removeToast} />
        {isLoading && <LoadingOverlay message={loadingMessage} />}
      </div>
    </BrowserRouter>
  );
}

export default App;
